import React from "react";

const EtTrinitySyncThoughts = ({ userId, onClose }) => {

  // First Created - 19 May 2025
  // Author - Atul Pandey
  // Purpose - Help user summarize insights across midday check-ins

  return (
    <div className="p-4">
      <h3 className="text-lg font-bold text-gray-800 mb-2">Sync Team/Client Thoughts</h3>
      <p className="text-sm text-gray-600 mb-2">[Summarize key themes from discussions or updates with others]</p>
      <button onClick={onClose} className="mt-4 text-sm text-blue-600 underline">Close</button>
    </div>
  );
};

export default EtTrinitySyncThoughts;